const menuData = [
    {
        titre: `Sales Growth Analysis\n(SGA)`,
        titreModule1: 'THE ESSENTIALS',
        descriptionModule1: `How does it work ?`,
        titreModule2: "LET'S GO DEEPER",
        descriptionModule2: 'An SGA report, step by step',
        titreModule3: 'IN PRACTICE',
        descriptionModule3: 'Understanding SGA in detail',
        descriptionText:
            'At the end of the module, you will have the possibility to download a \npocket memo with key information about the Sales Growth Analysis.',
    },
];

export default menuData;
